"use client";

import { c as _c } from "react/compiler-runtime";
import type { HeroConfig } from "@/config/counties/types";
import HeroSectionV2 from "@/components/landing/hero-section-v2";
type HeroSectionV2ClientProps = {
  data: HeroConfig;
  ctaHref: string;
};
export default function HeroSectionV2Client(t0) {
  const $ = _c(3);
  const {
    data,
    ctaHref
  } = t0;
  let t1;
  if ($[0] !== ctaHref || $[1] !== data) {
    t1 = <HeroSectionV2 data={data} ctaHref={ctaHref} />;
    $[0] = ctaHref;
    $[1] = data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}